import React from 'react';

// Bootstrap + Velzon theme: still used by the v1.1 Talent and Content pages
// (reactstrap). Primary is Preascent navy (config/default/_variables.scss).
import './assets/scss/themes.scss';

import HorusApp from "./horus/HorusApp";

function App() {
    return <HorusApp/>;
}

export default App;
